import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [//一级路由
    {
      path: '/',
      name: 'Login',
      component: () => import('@/views/Login.vue'),
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/index.vue'),
      children: [//二级路由

        {
          path: '/Client',
          name: 'Client',
          component: () => import('@/views/pages/client/index.vue')
        },
        {
          path: '/ClinentDetail',
          name: 'ClinentDetail',
          component: () => import('@/views/pages/client/detail.vue')
        },
        {
          path: '/POData',
          name: 'POData',
          component: () => import('@/views/pages/PO/index.vue')
        },
        {
          path: '/PODetail',
          name: 'PODetail',
          component: () => import('@/views/pages/PO/detail.vue')
        },
        {
          path: '/DailyReport',
          name: 'DailyReport',
          component: () => import('@/views/pages/DailyReport/index.vue')
        },
        {
          path: '/InspectionRecord',
          name: 'InspectionRecord',
          component: () => import('@/views/pages/InspectionRecord/index.vue')
        },
        {
          path: '/Audit',
          name: 'Audit',
          component: () => import('@/views/pages/Audit/index.vue')
        },
        {
          path: '/AuditDetail',
          name: 'AuditDetail',
          component: () => import('@/views/pages/Audit/detail.vue')
        },
        {
          path: '/TSortData',
          name: 'TSortData',
          component: () => import('@/views/pages/TSort/index.vue')
        },
        {
          path: '/TSortDetail',
          name: 'TSortDetail',
          component: () => import('@/views/pages/TSort/detail.vue')
        },
        {
          path: '/SSortData',
          name: 'SSortData',
          component: () => import('@/views/pages/SSort/index.vue')
        },
        {
          path: '/SSortDetail',
          name: 'SSortDetail',
          component: () => import('@/views/pages/SSort/detail.vue')
        },
        {
          path: '/UnitPrice',
          name: 'UnitPrice',
          component: () => import('@/views/pages/UnitPrice/index.vue')
        },
        {
          path: '/Role',
          name: 'Role',
          component: () => import('@/views/pages/sys/Role.vue')
        },
        {
          path: '/Employee',
          name: 'Employee',
          component: () => import('@/views/pages/employee/index.vue')
        },
        {
          path: '/employeeDetail',
          name: 'employeeDetail',
          component: () => import('@/views/pages/employee/detail.vue')
        },
        {
          path: '/Schedule',
          name: 'Schedule',
          component: () => import('@/views/pages/Schedule/index.vue')
        },
        {
          path: '/ScheduleDetail',
          name: 'ScheduleDetail',
          component: () => import('@/views/pages/Schedule/detail.vue')
        },
        {
          path: '/attendance',
          name: 'attendance',
          component: () => import('@/views/pages/attendance/index.vue')
        },
        {
          path: '/attendanceDetail',
          name: 'attendanceDetail',
          component: () => import('@/views/pages/attendance/detail.vue')
        },
        {
          path: '/group',
          name: 'group',
          component: () => import('@/views/pages/group/index.vue')
        },
        {
          path: '/groupDetail',
          name: 'groupDetail',
          component: () => import('@/views/pages/group/detail.vue')
        },
        {
          path: '/SSortHours',
          name: 'SSortHours',
          component: () => import('@/views/pages/Invoice/SSortHours.vue')
        },
        {
          path: '/Supplier',
          name: 'Supplier',
          component: () => import('@/views/pages/Invoice/Supplier.vue')
        },
        {
          path: '/InvoiceManagement',
          name: 'InvoiceManagement',
          component: () => import('@/views/pages/Invoice/InvoiceManagement.vue')
        },
        {
          path: '/InvoiceNoDetails',
          name: 'InvoiceNoDetails',
          component: () => import('@/views/pages/Invoice/InvoiceNoDetails.vue')
        },
        {
          path: '/UpdateInvoiceNo',
          name: 'UpdateInvoiceNo',
          component: () => import('@/views/pages/Invoice/UpdateInvoiceNo.vue')
        },
        {
          path: '/AddInvoiceNo',
          name: 'AddInvoiceNo',
          component: () => import('@/views/pages/Invoice/AddInvoiceNo.vue')
        },
        {
          path: '/ReimbursementNo',
          name: 'ReimbursementNo',
          component: () => import('@/views/pages/Reimbursement/ReimbursementNo.vue')
        },
        {
          path: '/ReimbursementNoDetails',
          name: 'ReimbursementNoDetails',
          component: () => import('@/views/pages/Reimbursement/ReimbursementNoDetails.vue')
        },
        {
          path: '/MyApprovals',
          name: 'MyApprovals',
          component: () => import('@/views/pages/Reimbursement/MyApprovals.vue')
        },
        {
          path: '/Holiday',
          name: 'Holiday',
          component: () => import('@/views/pages/sys/Holiday.vue')
        },{
          path: '/OaList',
          name: 'OaList',
          component: () => import('@/views/pages/OA/index.vue')
        },
        {
          path: '/OaDetail',
          name: 'OaDetail',
          component: () => import('@/views/pages/OA/detail.vue')
        },
        {
          path: '/WorkPlan',
          name: 'WorkPlan',
          component: () => import('@/views/pages/WorkPlan/index.vue')
        },
        {
          path: '/WorkPlanDetail',
          name: 'WorkPlanDetail',
          component: () => import('@/views/pages/WorkPlan/detail.vue')
        },
        {
          path: '/RoleManagment',
          name: 'RoleManagment',
          component: () => import('@/views/pages/sys/RoleManagment.vue')
        },{
          path: '/RoleDetails',
          name: 'RoleDetails',
          component: () => import('@/views/pages/sys/RoleDetails.vue')
        },{
          path: '/AssignUsers',
          name: 'AssignUsers',
          component: () => import('@/views/pages/sys/AssignUsers.vue')
        },
        {
          path: '/DicManagement',
          name: 'DicManagement',
          component: () => import('@/views/pages/sys/DicManagement.vue')
        },
        {
          path: '/DicDetails',
          name: 'DicDetails',
          component: () => import('@/views/pages/sys/DicDetails.vue')
        },
        {
          path: '/PaymentManagement',
          name: 'PaymentManagement',
          component: () => import('@/views/pages/Invoice/PaymentManagement.vue')
        },
        {
          path: '/PaymentReminderDetails',
          name: 'PaymentReminderDetails',
          component: () => import('@/views/pages/Invoice/PaymentReminderDetails.vue')
        },
        {
          path: '/SortDetails',
          name: 'SortDetails',
          component: () => import('@/views/pages/Invoice/SortDetails.vue')
        },
        {
          path: '/Statement',
          name: 'Statement',
          component: () => import('@/views/pages/Statement/index.vue')
        },
        {
          path: '/StatementDetail',
          name: 'StatementDetail',
          component: () => import('@/views/pages/Statement/detail.vue')
        },
        {
          path: '/StatementItem',
          name: 'StatementItem',
          component: () => import('@/views/pages/Statement/item.vue')
        },
      ]
    },
    {
      path: '/wmsindex',
      name: 'wmsindex',
      component: () => import('@/views/wmsindex.vue'),
      children: [//二级路由
        {
          path: '/RecevingNo',
          name: 'RecevingNo',
          component: () => import('@/views/pages/RecevingNo/index.vue')
        },
        {
          path: '/Add',
          name: 'Add',
          component: () => import('@/views/pages/RecevingNo/Add.vue')
        },
        {
          path: '/Recevdetail',
          name: 'Recevdetail',
          component: () => import('@/views/pages/RecevingNo/Recevdetail.vue')
        },
        {
          path: '/Outbound',
          name: 'Outbound',
          component: () => import('@/views/pages/Outbound/index.vue')
        },
        {
          path: '/OutboundAdd',
          name: 'OutboundAdd',
          component: () => import('@/views/pages/Outbound/Add.vue')
        },
        {
          path: '/outdetail',
          name: 'outdetail',
          component: () => import('@/views/pages/Outbound/outdetail.vue')
        },


        {
          path: '/shipping',
          name: 'shipping',
          component: () => import('@/views/pages/shipping/index.vue')
        },
        {
          path: '/shippingAdd',
          name: 'shippingAdd',
          component: () => import('@/views/pages/shipping/Add.vue')
        },
        {
          path: '/shippingDetail',
          name: 'shippingDetail',
          component: () => import('@/views/pages/shipping/shippingDetail.vue')
        },
        {
          path: '/InventoryDetail',
          name: 'InventoryDetail',
          component: () => import('@/views/pages/Inventory/detail.vue')
        },
        {
          path: '/Inventorylog',
          name: 'Inventorylog',
          component: () => import('@/views/pages/Inventory/log.vue')
        },
        {
          path: '/WarehouseIndex',
          name: 'WarehouseIndex',
          component: () => import('@/views/pages/Warehouse/index.vue')
        },
        {
          path: '/WarehouseDetail',
          name: 'WarehouseDetail',
          component: () => import('@/views/pages/Warehouse/detail.vue')
        },
        {
          path: '/WarehouseAdd',
          name: 'WarehouseAdd',
          component: () => import('@/views/pages/Warehouse/Add.vue')
        },

        {
          path: '/AreaIndex',
          name: 'AreaIndex',
          component: () => import('@/views/pages/Area/index.vue')
        },
        {
          path: '/AreaDetail',
          name: 'AreaDetail',
          component: () => import('@/views/pages/Area/detail.vue')
        },
        {
          path: '/AreaAdd',
          name: 'AreaAdd',
          component: () => import('@/views/pages/Area/Add.vue')
        },
        {
          path: '/storageIndex',
          name: 'storageIndex',
          component: () => import('@/views/pages/storage/index.vue')
        },
        {
          path: '/storageDetail',
          name: 'storageDetail',
          component: () => import('@/views/pages/storage/detail.vue')
        },
        {
          path: '/storageAdd',
          name: 'storageAdd',
          component: () => import('@/views/pages/storage/Add.vue')
        },
        {
          path: '/dockIndex',
          name: 'dockIndex',
          component: () => import('@/views/pages/dock/index.vue')
        },
        {
          path: '/dockDetail',
          name: 'dockDetail',
          component: () => import('@/views/pages/dock/detail.vue')
        },
        {
          path: '/dockAdd',
          name: 'dockAdd',
          component: () => import('@/views/pages/dock/Add.vue')
        },


        {
          path: '/customer',
          name: 'customer',
          component: () => import('@/views/pages/basic/customer.vue')
        },
        {
          path: '/customerDetail',
          name: 'customerDetail',
          component: () => import('@/views/pages/basic/detail.vue')
        },
        {
          path: '/customerAdd',
          name: 'customerAdd',
          component: () => import('@/views/pages/basic/customerAdd.vue')
        }
        ,
        {
          path: '/SortDashboard',
          name: 'SortDashboard',
          component: () => import('@/views/pages/Dashboard/SortDashboard.vue')
        },
        {
          path: '/Sku',
          name: 'Sku',
          component: () => import('@/views/pages/Sku/index.vue')
        },
        {
          path: '/SkuDetail',
          name: 'SkuDetail',
          component: () => import('@/views/pages/Sku/detail.vue')
        }

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js